import { environment } from "../../../environments/environment";

export const APP_NAME = "StrangerYap" as const;

export const SUPPORT_EMAIL = "support@strangeryap.fun" as const;

function resolveApiBase(): string {
  if (environment.apiBaseUrl) return environment.apiBaseUrl;
  // In prod with no explicit URL, derive from window.location (same-host deployment)
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.host}`;
  }
  return "";
}

function resolveSocketUrl(): string {
  if (environment.socketUrl) return environment.socketUrl;
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.host}/realtime`;
  }
  return "/realtime";
}

function resolveVideoSocketUrl(): string {
  if (environment.videoSocketUrl) return environment.videoSocketUrl;
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.host}/video`;
  }
  return "/video";
}

export const APP_CONSTANTS = {
  get apiBaseUrl() {
    return resolveApiBase();
  },
  get socketUrl() {
    return resolveSocketUrl();
  },
  get videoSocketUrl() {
    return resolveVideoSocketUrl();
  },
  maxInterests: 10,
  maxMessageLength: 2000,
  defaultDisplayName: "Stranger",
  defaultCountry: "",
  defaultAvatarUrl: "",
  media: {
    video: {
      width: { ideal: 1280 },
      height: { ideal: 720 },
      facingMode: "user",
    },
    audio: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      suppressLocalAudioPlayback: true,
    },
  },
  siteUrl: "https://strangeryap.fun",
  siteName: APP_NAME,
  defaultOgImage: "https://strangeryap.fun/assets/og-image.svg",
  socketEvents: {
    match: {
      restore: "match:restore",
      restored: "match:restored",
      restoreFailed: "match:restore-failed",
      peerSkipped: "match:peer-skipped",
      peerLeft: "match:peer-left",
      waiting: "match:waiting",
      found: "match:found",
      skipped: "match:skipped",
      cancelled: "match:cancelled",
      join: "match:join",
      cancel: "match:cancel",
      heartbeat: "match:heartbeat",
      skip: "match:skip",
      block: "moderation:block",
      exclude: "moderation:exclude",
      completed: "moderation:completed",
      typing: "chat:typing",
      imageViewed: "chat:image-viewed",
      message: "chat:message",
      messageReceived: "chat:message-received",
      staleMatch: "chat:stale-match",
      profileUpdated: "peer:profile-updated",
    },
    video: {
      waiting: "video:waiting",
      found: "video:found",
      offer: "video:offer",
      answer: "video:answer",
      iceCandidate: "video:ice-candidate",
      peerSkipped: "video:peer-skipped",
      peerLeft: "video:peer-left",
      cancelled: "video:cancelled",
      join: "video:join",
      cancel: "video:cancel",
      skip: "video:skip",
    },
  },
  interests: [
    "Music",
    "Travel",
    "Movies",
    "Gaming",
    "Books",
    "Food",
    "Coding",
    "Sports",
  ],
} as const;
